import React from 'react';
import { ProductType } from '../types/subscription';

interface SubscriptionGateProps {
  children: React.ReactNode;
  requiredProduct?: ProductType;
  requiredFeature?: string;
  fallback?: React.ReactNode;
  showUpgrade?: boolean;
}

interface UpgradePromptProps {
  requiredProduct?: ProductType;
  requiredFeature?: string;
}

const UpgradePrompt: React.FC<UpgradePromptProps> = () => null;

export const SubscriptionGate = React.forwardRef<HTMLDivElement, SubscriptionGateProps>((
  { children },
  ref
) => {
  // 订阅暂未接入：始终显示内容
  return <div ref={ref}>{children}</div>;
});

SubscriptionGate.displayName = 'SubscriptionGate';

// 简化后的权限检查：始终允许访问
export const usePermissionCheck = () => {
  const checkAccess = (_requiredProduct?: ProductType, _requiredFeature?: string): boolean => true;
  const getAccessLevel = (): 'free' | 'partial' | 'premium' => 'free';
  const hasProductAccess = (_product: ProductType) => true;
  const hasFeature = (_feature: string) => true;

  return {
    checkAccess,
    getAccessLevel,
    hasProductAccess,
    hasFeature,
  };
};

export default SubscriptionGate;